import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  Container,
  Header,
  Icon,
  Menu,
  Segment
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import InformePorMatriculaView from './InformePorMatriculaView';
import InformeAvanzadoView from './InformeAvanzadoView';
import InformePersonasView from './InformePersonasView';
import InformeLibrosView from './InformeLibrosView';
import InformeEconomicoView from './InformeEconomicoView';

class CooperativasView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Header as="h2">
          <Icon name="users" />
          <Header.Content>
            Informes
            <Header.Subheader>
              Busqueda y Reportes
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu attached="top" tabular>
          <Menu.Item
            as={Link} to="/informes/matricula"
            active={!!window.location.pathname.match(new RegExp(`^/informes/matricula/?$`))}
            name="matricula" />
          <Menu.Item
            as={Link} to="/informes/avanzado"
            active={!!window.location.pathname.match(new RegExp(`^/informes/avanzado/?$`))}
            name="avanzado" />
          <Menu.Item
            as={Link} to="/informes/personas"
            active={!!window.location.pathname.match(new RegExp(`^/informes/personas/?$`))}
            name="personas" />
          <Menu.Item
            as={Link} to="/informes/libros"
            active={!!window.location.pathname.match(new RegExp(`^/informes/libros/?$`))}
            name="libros" />
          {/* <Menu.Item
            as={Link} to="/informes/economico"
            active={!!window.location.pathname.match(new RegExp(`^/informes/economico/?$`))}
            name="economico" /> */}
        </Menu>
        <Route path={`${this.props.match.url}/matricula`} render={() => {
          return (
            <Segment attached="bottom">
              <InformePorMatriculaView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/avanzado`} render={() => {
          return (
            <Segment attached="bottom">
              <InformeAvanzadoView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/personas`} render={() => {
          return (
            <Segment attached="bottom">
              <InformePersonasView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/libros`} render={() => {
          return (
            <Segment attached="bottom">
              <InformeLibrosView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/economico`} render={() => {
          return (
            <Segment attached="bottom">
              <InformeEconomicoView />
            </Segment>
          );
        }} />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    CooperativasView.mapStateToProps,
    CooperativasView.mapDispatchToProps
  )(CooperativasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/InformesView.js